import { TrainerDTO } from "@modules/shared/entities/users/users.entity";
import { FiArrowRight } from "react-icons/fi";

export default function AdOverview({
  trainer,
}: {
  trainer: TrainerDTO | undefined;
}) {
  return (
    <div className="tab-pane fade show active">
      {/* Bio */}
      <p className="text-muted">{trainer?.bio}</p>

      <div className="row gap-4 justify-content-around">
        <div className="col col-lg-5">
          {/* Trainer Card */}
          <div className="card row shadow-lg p-3 mb-5 bg-body rounded text-capitalize">
            <h6 className="mb-0">Trainer Information:</h6>
            <ul className="list-unstyled mt-4 text-muted">
              <li className="d-flex justify-content-between align-items-center mt-1">
                <span>
                  <FiArrowRight className="text-primary" /> Name
                </span>
                <span>{trainer?.name ? trainer?.name : "_"}</span>
              </li>
              <li className="d-flex justify-content-between align-items-center mt-1">
                <span>
                  <FiArrowRight className="text-primary" /> Phone
                </span>
                <span>{trainer?.phoneNumber ? trainer?.phoneNumber : "_"}</span>
              </li>
              <li className="d-flex justify-content-between align-items-center mt-1">
                <span>
                  <FiArrowRight className="text-primary" /> Birth
                </span>
                <span>
                  {trainer?.dateOfBirth
                    ? (() => {
                        const d = new Date(trainer.dateOfBirth);
                        const day = String(d.getDate()).slice(-2);
                        const month = String(d.getMonth() + 1).slice(-2);
                        const year = d.getFullYear();
                        return `${day}/${month}/${year}`;
                      })()
                    : "_"}
                </span>
              </li>
              <li className="d-flex justify-content-between align-items-center mt-1">
                <span>
                  <FiArrowRight className="text-primary" /> Gender
                </span>
                <span>{trainer?.gender ? trainer?.gender : "_"}</span>
              </li>
              <li className="d-flex justify-content-between align-items-center mt-1">
                <span>
                  <FiArrowRight className="text-primary" /> Address
                </span>
                {trainer?.address ? (
                  <span className="ms-2">
                    <span>
                      {trainer?.address ? trainer?.address?.district : "__"}
                    </span>
                    <span>
                      {trainer?.address?.district ? (
                        <span>, </span>
                      ) : (
                        <span></span>
                      )}
                    </span>
                    <span>
                      {trainer?.address ? trainer?.address?.city : "__"}
                    </span>
                    <span>
                      {trainer?.address?.city ? <span>, </span> : <span></span>}
                    </span>
                    <span>
                      {trainer?.address ? trainer?.address?.country : "__"}
                    </span>
                  </span>
                ) : (
                  <span className="ms-2">_</span>
                )}
              </li>
            </ul>
          </div>
        </div>

        <div className="col-12 col-lg-5">
          <div className="card row shadow-lg p-3 mb-5 bg-body rounded">
            {/* Trainer Card */}
            <h6 className="mb-0">More Information:</h6>
            <ul className="list-unstyled mt-4 text-muted">
              <li className="d-flex justify-content-between align-items-center mt-1">
                <span>
                  <FiArrowRight className="text-primary" /> Email
                </span>
                <span>{trainer?.email ? trainer?.email : "_"}</span>
              </li>
              <li className="d-flex justify-content-between align-items-center mt-1">
                <span>
                  <FiArrowRight className="text-primary" /> Username
                </span>
                <span>{trainer?.username ? trainer?.username : "_"}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
